import React from 'react'
import {ImAppleinc} from 'react-icons/im'

const Download = () => {
  return (
   <section className='bg-primarygray md:pt-20 pt-14 pb-14' >  
              <div className='container mx-auto  text-center'>
                <div className='font-bold  md:w-1/2 text-2xl sm:text-4xl mx-auto'> 
                  <h1 className=''> What are you waiting for?  </h1>
                  <h1 className='md:mt-4'> Download Now!</h1>
                  </div>
                 
                    <div className='flex justify-center text-[#ffffff] space-x-4 lg:mt-6 mt-10'> 
                         <div className='flex  sm:w-36 w-fit px-1 h-10 hover:bg-primaryblue hover:text-[#ffffff] bg-[#000000]  hover:border-0 space-x-2 hover:cursor-pointer rounded-md'>
                           
                         <ImAppleinc className='text-2xl mt-1 '> </ImAppleinc>
                          <div className='' > 
                              <h1 className='text-[10px] mt-0.5  text-start'> Download on the  </h1>
                              <h1 className='mt-[-4px] text-start text-sm'> App Store</h1>
                          </div>
                        </div>

                         <div className='flex  sm:w-36 w-fit px-1 h-10 hover:bg-primaryblue hover:text-[#ffffff] bg-[#000000]  hover:border-0 space-x-2 hover:cursor-pointer rounded-md'>
                           
                          <img className='h-6 mt-2 ml-2' src='./image/google.webp' alt='google play'/>
                          <div className='' > 
                              <h1 className='text-[9px]  mt-1 text-start'> GET IT ON </h1>
                              <h1 className='mt-[-3px] text-sm'> Google Play</h1>
                          </div>
                        </div>
                    </div>
                </div> 

   </section>
  )
}

export default Download